import React from 'react';
import { CTAButton } from './CTAButton';
import { BoxImage } from './BoxImage';
export function FinalCTA() {
  return <section className="border-t-4 border-signal bg-navy-soft text-center" data-id="element-50" data-mp="3udf8az5tp7i7">
      <div className="px-3 py-4 sm:px-6" data-id="element-51" data-mp="c7afoahnmgj6">
        <div className="mx-auto max-w-xl" data-id="element-52" data-mp="c83ori435i4h">
          <h2 className="font-display text-[1.55rem] font-extrabold uppercase leading-none text-white sm:text-[2.1rem]" data-id="element-53" data-mp="85fd72nzlx3t">
            ONE LAST <span className="text-signal" data-id="element-54" data-mp="m3x0iz9zd7l7">QUESTION</span>
          </h2>
          <p className="mt-1.5 text-[0.8rem] leading-[1.4] text-white/85 sm:text-[0.92rem]" data-id="element-55" data-mp="h6dkbttq2kqm">
            When you're facing an unexplained optical loss, a confusing OTDR trace, an intermittent fiber link, a
            defective splice, or a complex FTTH distribution failure...
          </p>
          <p className="mt-1 font-display text-[1.02rem] font-extrabold uppercase leading-tight text-gold sm:text-[1.3rem]" data-id="element-56" data-mp="14v6ilwxth4oe">
            Do you have a structured system to analyze the evidence, isolate the fault, and determine what to test next?
          </p>
          <p className="mt-1 text-[0.8rem] leading-[1.4] text-white/85 sm:text-[0.92rem]" data-id="element-57" data-mp="2c6hfy6edthbk">
            Stop relying on scattered references, disconnected measurements, and unstructured troubleshooting.
          </p>
          <p className="mt-1 font-display text-[0.74rem] font-extrabold uppercase text-signal sm:text-[0.88rem]" data-id="element-58" data-mp="2m572ich83py5">
            Identify the fault. Analyze the trace. Isolate the cause. Verify the result.
          </p>

          <BoxImage className="mx-auto mt-2 max-w-[260px] sm:max-w-[320px]" data-id="element-59" data-mp="302c4a09wm2nl" />

          <p className="mt-2 font-display text-[1.3rem] font-extrabold uppercase leading-none text-white sm:text-[1.75rem]" data-id="element-60" data-mp="300944nf1et55">
            🔬 FIBER OPTIC <span className="text-signal" data-id="element-61" data-mp="39solbiiifdoz">DIAGNOSTIC PRO™</span>
          </p>
          <p className="mt-1 font-display text-[0.64rem] font-extrabold uppercase text-white/75 sm:text-[0.8rem]" data-id="element-62" data-mp="3errrx7e51rz2">
            THE COMPLETE FIBER OPTIC FAULT-FINDING &amp; TROUBLESHOOTING SYSTEM
          </p>
          <p className="mt-0.5 font-display text-[0.6rem] font-extrabold uppercase tracking-[0.06em] text-gold sm:text-[0.76rem]" data-id="element-63" data-mp="1jntqzs9obvxa">
            Identify • Measure • Analyze • Isolate • Repair • Verify
          </p>

          <div className="mx-auto mt-2 max-w-md" data-id="element-64" data-mp="1sgwyzl1jvgkj">
            <p className="font-display text-[0.8rem] font-extrabold uppercase text-white sm:text-[0.95rem]" data-id="element-65" data-mp="1sirjwzctn8om">
              🔥 GET THE COMPLETE SYSTEM TODAY —{' '}
              <span className="whitespace-nowrap rounded bg-gold px-1.5 text-navy" data-id="element-66" data-mp="22djj27m1y3li">$27 USD</span>
            </p>
            <div className="mt-1.5" data-id="element-67" data-mp="1xf88tvruhr2r">
              <CTAButton label="🔬 GET FIBER OPTIC DIAGNOSTIC PRO™" data-id="element-68" data-mp="2bfj0h10zb9oz" />
            </div>
            <p className="mt-2 text-[0.66rem] font-bold uppercase tracking-wide text-white/85 sm:text-xs" data-id="element-69" data-mp="2bd6m0xufjhgo">
              Immediate Access • Digital Delivery
            </p>
            <p className="mt-0.5 text-[0.66rem] font-bold uppercase tracking-wide text-gold sm:text-xs" data-id="element-70" data-mp="h20783dzed9h">
              🛡️ 7-Day Money-Back Guarantee
            </p>
          </div>
        </div>
      </div>
    </section>;
}